/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import {
    bool,
    func, number,
} from 'prop-types';
import { useDispatch } from 'react-redux';
import style from './BYOProductItems.module.css';
import LinearProgressBar from './LinearProgressBar';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const ProgressBar = ({
    totalProductSelected,
    maxSelectableForSku,
    removeItem,
    floatingProgressBar,
}) => {
    useStyles(style);
    const dispatch = useDispatch();
    return (
        <div className={floatingProgressBar ? style.floatingProgressBar : style.stickyProgressBarContainer} id="progress_bar_mobile">
            <div className={style.itemNumberContainer}>
                <p className={style.itemNumbers}>
                    {`Add ${maxSelectableForSku} Items`}
                </p>
                <p className={style.itemNumbers}>
                    {`(${totalProductSelected} of ${maxSelectableForSku} Added)`}
                </p>
            </div>

            <div className={style.progressBarRoot}>
                <LinearProgressBar
                    total={maxSelectableForSku}
                    selected={totalProductSelected}
                />
            </div>
            {!floatingProgressBar && (
                <div className={style.clearNumberContainer}>
                    <p className={style.itemNumbers}>
                        {`(${totalProductSelected} of ${maxSelectableForSku} Added)`}
                    </p>
                    {totalProductSelected >= 1 && (
                        <span
                            className={style.clearSelection}
                            component="span"
                            variant="body2"
                            color="textPrimary"
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            role="button"
                            onClick={() => {
                                removeItem();
                                dispatch(trackEvent({
                                    eventCategory: 'BYO',
                                    eventAction: 'Progress bar Clear Selections',
                                    eventLabel: 'Removed all items',
                                }));
                            }}
                        >
                            Clear Selections
                        </span>
                    )}
                </div>
            )}

        </div>

    );
};
ProgressBar.propTypes = {
    totalProductSelected: number,
    maxSelectableForSku: number,
    removeItem: func.isRequired,
    floatingProgressBar: bool,
};
ProgressBar.defaultProps = {
    maxSelectableForSku: 0,
    totalProductSelected: 0,
    floatingProgressBar: false,
};
export default ProgressBar;
